import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';

import { H3 } from '../text';

import styles from './loading.styles';
import { createContainer } from '@dbk-legacy/muster/react';

function Loading({ content, isPage, noPadding }) {

const upperClass =  noPadding  ? "columns small-12 center"  : "columns small-12 center loadingIcon" 

  return (
    <div className="row">
      <div className= {upperClass} >                     {/*padding for tabs*/}
        <span className={isPage ? "loadingIcon" : ""} style=  { noPadding ? {'paddingTop': '0vh'} : null  }>               {/*padding for pages and popup*/}
          <View style={styles.container}>
              {content}
          </View>
        </span>
      

      </div>

    </div>
  );
}

Loading.defaultProps = {
  content: (
    <H3>Loading...</H3>
  ),
  isPage: false,
};

Loading.propTypes = {
  content: PropTypes.node.isRequired,
  isPage: PropTypes.bool,
};

export default createContainer({
	$queries: {
	screen:{
      height:true,
    },
    },
})(Loading);
export { Loading };

